import gql from 'graphql-tag';

export const AddMockExamStudentExams = gql`
  mutation AddMockExamStudentExams(
    $roundCode: String!
    $examsInput: [MockExamStudentExamCreateInput]!
  ) {
    addMockExamStudentExams(roundCode: $roundCode, examsInput: $examsInput) {
      success
      error
      studentExamCards {
        studentExamCards {
          roundCode
          locationCode
          subjectCode
        }
      }
    }
  }
`;

export const DeleteMockExamStudentExam = gql`
  mutation DeleteMockExamStudentExam($roundCode: String!, $studentExamCardId: String!) {
    deleteMockExamStudentExam(roundCode: $roundCode, studentExamCardId: $studentExamCardId) {
      success
      error
      studentExamCards {
        studentExamCards {
          roundCode
          locationCode
          subjectCode
        }
      }
    }
  }
`;
